<template>
    <v-layout row>
        <v-flex xs12>
            <v-card>
                <v-card-title primary-title>
                    <div class="headline">Import/Export</div>
                </v-card-title>
                <v-container grid-list-xl fluid>
                    <v-layout row wrap justify-space-around>
                        <v-flex xs12 sm6 d-flex>
                            <v-list two-line subheader>
                                <v-subheader>Imports</v-subheader>
                                <v-list-tile avatar @click="$router.push({name: 'dataops.imports.gtschedule', params: {firebaseUser: firebaseUser, user: user, systemConfig: systemConfig}})">
                                    <v-list-tile-content>
                                        <v-list-tile-title>GT Entry Delivery Schedule</v-list-tile-title>
                                        <v-list-tile-sub-title>Import the entry delivery schedule coding for Great Taste</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile avatar @click="$router.push({name: 'dataops.imports.wcresults', params: {firebaseUser: firebaseUser, user: user, systemConfig: systemConfig}})">
                                    <v-list-tile-content>
                                        <v-list-tile-title>WCA Results</v-list-tile-title>
                                        <v-list-tile-sub-title>Import results for World Cheese Awards</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <!--<v-list-tile avatar @click="">-->
                                    <!--<v-list-tile-content>-->
                                        <!--<v-list-tile-title>Not Configured</v-list-tile-title>-->
                                        <!--<v-list-tile-sub-title>No imports are currently configured</v-list-tile-sub-title>-->
                                    <!--</v-list-tile-content>-->
                                <!--</v-list-tile>-->
                            </v-list>
                        </v-flex>
                        <v-flex xs12 sm6 d-flex>
                            <v-list two-line subheader>
                                <v-subheader>Exports</v-subheader>
                                <v-list-tile avatar @click="$router.push({name: 'dataops.exports.entries'})">
                                    <v-list-tile-content>
                                        <v-list-tile-title>Entries</v-list-tile-title>
                                        <v-list-tile-sub-title>Run the normal Guild Ops Export</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-divider></v-divider>
                                <v-list-tile avatar @click="$router.push({name: 'dataops.exports.comments'})">
                                    <v-list-tile-content>
                                        <v-list-tile-title>Judging Comments</v-list-tile-title>
                                        <v-list-tile-sub-title>Run an export of judging comments</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-divider></v-divider>
                                <v-list-tile avatar @click="$router.push({name: 'dataops.exports.results'})">
                                    <v-list-tile-content>
                                        <v-list-tile-title>Results</v-list-tile-title>
                                        <v-list-tile-sub-title>Run an export of entries with judging results</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-divider></v-divider>
                                <v-list-tile avatar @click="$router.push({name: 'dataops.exports.orders'})">
                                    <v-list-tile-content>
                                        <v-list-tile-title>Orders</v-list-tile-title>
                                        <v-list-tile-sub-title>Run an export of orders</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-divider></v-divider>
                                <v-list-tile avatar @click="$router.push({name: 'dataops.exports.members'})">
                                    <v-list-tile-content>
                                        <v-list-tile-title>Members</v-list-tile-title>
                                        <v-list-tile-sub-title>Run an export Guild members</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-divider></v-divider>
                                <v-list-tile avatar @click="$router.push({name: 'dataops.exports.sage'})">
                                    <v-list-tile-content>
                                        <v-list-tile-title>Sage Accounting</v-list-tile-title>
                                        <v-list-tile-sub-title>Run an export of SagePay orders</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                        </v-flex>
                        <v-flex xs12 class="text-xs-center">
                            <router-link :to="{name: 'dataops.jobs.list'}">View Initiated Jobs</router-link>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
  export default {
    name: 'dataops-dashboard',
    props: {
      firebaseUser: {
        required: true
      },
      user: {
        required: true
      },
      systemConfig: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style lang="scss"></style>
